import React from 'react';
import { CircleCheck, LayoutGrid, List, MapPin, Truck } from 'lucide-react';

/**
 * Abas das telas de lista (5630): KANBAN volta ao quadro de cards; a aba de cada coluna abre a lista
 * dela; Lista de viagens, a consolidada.
 */
export const TABS = [
  { key: 'KANBAN', label: 'Kanban', icon: LayoutGrid, kind: null },
  { key: 'AVAILABLE', label: 'Pré cargas/cargas', icon: Truck, kind: 'availableList' },
  { key: 'ATTENDED', label: 'Atendidas', icon: CircleCheck, kind: 'attendedList' },
  { key: 'IN_TRANSIT', label: 'Em viagem', icon: Truck, kind: 'inTransitList' },
  { key: 'AT_DESTINATION', label: 'No destino', icon: MapPin, kind: 'atDestinationList' },
  { key: 'TRIPS', label: 'Lista de viagens', icon: List, kind: 'trips' },
];

/**
 * Só aparece com uma lista aberta. `disabled(tab)` repete as regras dos ícones de lista e do botão
 * Listar viagens; a aba KANBAN nunca fica bloqueada.
 */
export default function KanbanTabs({ active, disabled, onSelect }) {
  return (
    <nav className="tc-k-tabs" aria-label="Listas do Kanban">
      {TABS.map((tab) => {
        const Icon = tab.icon;
        const current = active === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            className="tc-k-tab"
            aria-current={current ? 'page' : undefined}
            disabled={!current && tab.key !== 'KANBAN' && disabled(tab)}
            onClick={() => !current && onSelect(tab)}
          >
            <Icon size={16} aria-hidden="true" />
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
